import React from 'react';
import {connect} from 'react-redux';
import {BaseFilterComponent} from 'components/organisms/used-players-list/components/filter/sports/f1/classic';

class FilterComponent extends BaseFilterComponent {
    render() {
        return <div className="tabs-chk-fixed">{this.prepareTabs()}</div>;
    }
}

function mapStatesToProps(state) {
    return {
        modesConfig: state.modesConfig,
        filters: state.usedPlayers.filters,
        sportConfig: state.sportConfig,
    };
}

const Filter = connect(mapStatesToProps)(FilterComponent);

export {Filter};
